import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import type { Action } from './actions.tsx';
import rootReducer from './reducer.tsx';
import type { State } from './types.tsx';

const createStore = (rootEpic?: Epic<Action, State>) =>
	initiateStore<State, Action, undefined>({
		appName: 'release-version',
		rootReducer,
		rootEpic,
	});

export default createStore;
